module.exports = __webpack_public_path__ + "static/user-demographics-3c3836b7064f116c2ad25d6fc607793c.png";